const stopAudio = (audio) => {
    if (audio) {
        audio.pause();
        audio.currentTime = 0;
    }
}

export default stopAudio;